import { connect, ConnectedProps } from 'react-redux';
import {
  buildDateFilter,
  buildAggregationFilters,
} from '../search-snippets/aside/filter-box/filterBoxUtils';
import {
  hasAggregationSelected,
  hasAggregation,
} from './searchFiltersBarUtils';
import { StateType } from '../../../state/reducers';

function countOthers(queryParams: StateType['queryParams']) {
  let otherCount = 0;

  if (queryParams.excludeMoyensAnnexes) {
    otherCount += 1;
  }
  if (queryParams.parties.defendant) {
    otherCount += 1;
  }
  if (queryParams.parties.plaintiff) {
    otherCount += 1;
  }

  otherCount += buildAggregationFilters(queryParams.aggregationsPaths, 'publi')
    .length;

  otherCount += buildAggregationFilters(
    queryParams.aggregationsPaths,
    'solution',
  ).length;

  return otherCount;
}

const mapState = ({ aggregations, queryParams, search }: StateType) => {
  const otherCount = countOthers(queryParams);
  return {
    enableWatchers: search.enableWatchers,
    enableMoreFilters: search.enableMoreFilters,
    shouldDisplayDomaine: hasAggregation(aggregations, 'domaine'),
    shouldDisplayJuridiction: hasAggregation(aggregations, 'juridiction'),
    hasDateSelected: !!queryParams.dates.from || !!queryParams.dates.to,
    hasJurisdictionSelected: hasAggregationSelected(queryParams, 'juridiction'),
    hasDomaineSelected: hasAggregationSelected(queryParams, 'domaine'),
    dateLabel: queryParams.dates ? buildDateFilter(queryParams.dates) : null,
    jurisdictionCount: buildAggregationFilters(
      queryParams.aggregationsPaths,
      'juridiction',
    ).length,
    domaineCount: buildAggregationFilters(
      queryParams.aggregationsPaths,
      'domaine',
    ).length,
    otherCount,
    type: queryParams.type,
  };
};

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
